import type {
  CreateSavedFilterRequest,
  RenameSavedFilterRequest,
  ResponseType,
  SavedFilter,
  SavedFiltersResponse,
} from '@/types';

import { apiClient } from './apiClient';

export const savedFilterProvider = {
  createSavedFilter: async (
    payload: CreateSavedFilterRequest
  ): Promise<ResponseType<SavedFilter>> => apiClient<SavedFilter>('/savedFilter', 'POST', payload),

  getSavedFilters: async (): Promise<ResponseType<SavedFiltersResponse>> =>
    apiClient<SavedFiltersResponse>('/savedFilter', 'GET'),

  renameSavedFilter: async (
    id: string,
    request: RenameSavedFilterRequest
  ): Promise<ResponseType<SavedFilter>> =>
    apiClient<SavedFilter>(`/savedFilter/${id}`, 'PATCH', { name: request.name }),

  deleteSavedFilter: async (id: string): Promise<ResponseType<null>> =>
    apiClient<null>(`/savedFilter/${id}`, 'DELETE'),
};
